export default {
	methods: {
		getPropertyDescription(realEstateData) {
			if (realEstateData.basicData) {
				let h2Text = null;
				let numberOfRooms, numberOfHalfRooms, rooms, areaWithComma;
				const area = realEstateData.basicData.area ? `${realEstateData.basicData.area} ${this.$t('AADAT.sqm')}` : '';
				switch (realEstateData.propertyData.type) {
					case 'flat':
					case 'house':
						numberOfRooms = realEstateData.basicData.numberOfRooms;
						numberOfHalfRooms = realEstateData.basicData.numberOfHalfRooms ? `+${realEstateData.basicData.numberOfHalfRooms}` : '';
						rooms = numberOfRooms ? `${numberOfRooms}${numberOfHalfRooms} ${this.$t('AADAT.roomH2')}` : '';
						const buildingStructure = realEstateData.buildingData.buildingStructure
							? realEstateData.buildingData.buildingStructure == 'brick'
								? `${this.$t(`AADAT.${realEstateData.buildingData.buildingStructure}`).toLowerCase()} ${this.$t('AADAT.built')}`
								: this.$t(`AADAT.${realEstateData.buildingData.buildingStructure}`).toLowerCase()
							: '';

						const buildingStructureWithComma = rooms && buildingStructure ? `, ${buildingStructure}` : buildingStructure;
						areaWithComma = (rooms || buildingStructure) && area ? `, ${area}` : area;
						h2Text = `${rooms}${buildingStructureWithComma}${areaWithComma}`;
						break;
					case 'projectEstate':
						numberOfRooms = realEstateData.basicData.numberOfRooms;
						numberOfHalfRooms = realEstateData.basicData.numberOfHalfRooms ? `+${realEstateData.basicData.numberOfHalfRooms}` : '';
						rooms = numberOfRooms ? `${numberOfRooms}${numberOfHalfRooms} ${this.$t('AADAT.roomH2')}` : '';
						areaWithComma = rooms && area ? `, ${area}` : area;
						h2Text = `${rooms}${areaWithComma}`;		
						break;
					default:
						h2Text = area;
				}
				return h2Text;
			}
		}
	}
};
